import { render, staticRenderFns } from "./CustomerFilesTab.vue?vue&type=template&id=7abbb184&"
import script from "./CustomerFilesTab.vue?vue&type=script&lang=js&"
export * from "./CustomerFilesTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports